import ReferralActionType from 'actions/referral/referralActionType';

const initialState = {
  playerReferralPeriods: {},
  referralAccumulatedPeriods: {},
  referralTransferredPeriods: {},
  referralFailedPeriods: {},
  referral: {},
  referees: {},
  playerReferralReferees: {},
  playerReferrals: {},
};

const referralReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case ReferralActionType.SAVE_REFERRAL:
    return {
      ...state,
      referral: payload.data,
    };
  case ReferralActionType.RESET_REFERRAL:
    return {
      ...state,
      referral: {},
    };
  case ReferralActionType.SAVE_REFERRAL_REFEREES:
    return {
      ...state,
      referees: payload.data,
    };
  case ReferralActionType.RESET_REFERRAL_REFEREES:
    return {
      ...state,
      referees: {},
    };
  case ReferralActionType.SAVE_PLAYER_REFERRAL_REFEREES:
    return {
      ...state,
      playerReferralReferees: payload.data,
    };
  case ReferralActionType.RESET_PLAYER_REFERRAL_REFEREES:
    return {
      ...state,
      playerReferralReferees: {},
    };
  case ReferralActionType.SAVE_PLAYER_REFERRALS:
    return {
      ...state,
      playerReferrals: payload.data,
    };
  case ReferralActionType.RESET_PLAYER_REFERRALS:
    return {
      ...state,
      playerReferrals: {},
    };
  case ReferralActionType.SAVE_PLAYER_REFERRAL_PERIODS:
    return {
      ...state,
      playerReferralPeriods: payload.data,
    };
  case ReferralActionType.RESET_PLAYER_REFERRAL_PERIODS:
    return {
      ...state,
      playerReferralPeriods: {},
    };
  case ReferralActionType.SAVE_REFERRAL_ACCUMULATED_PERIODS:
    return {
      ...state,
      referralAccumulatedPeriods: payload.data,
    };
  case ReferralActionType.SAVE_REFERRAL_TRANSFERRED_PERIODS:
    return {
      ...state,
      referralTransferredPeriods: payload.data,
    };
  case ReferralActionType.SAVE_REFERRAL_FAILED_PERIODS:
    return {
      ...state,
      referralFailedPeriods: payload.data,
    };
  default:
    return state;
  }
};

export default referralReducer;
